export const LogOut = ()  => {

    localStorage.clear()

   return true
}

export const GetIDUser = ()  => {

   return localStorage.getItem('us_id') ?? '0'
}

export const GetToken = ()  => {

    return  localStorage.getItem('us_tk') ?? ''
}

export const GetNameUser = () => {

    return localStorage.getItem('us_nm') ?? ''
}

export const GetRegister= () => {

    return  localStorage.getItem('us_re') ?? ''
}

export const GetUserType = ():number => {

    const profID = localStorage.getItem('us_profID') ?? '0'
    return parseInt(profID)
}

export const canAccessRouter = (currentRouter:string) => {

    const profID = localStorage.getItem('us_profID') ?? '0'

    if( parseInt(profID) === 3 && (currentRouter === 'users' || currentRouter === 'result' || currentRouter === 'languages') ) 
        return false

    return true
}

export const formatUSData = (data:Date): string  => {
        
    const dia  = data.getDate().toString()
    const diaF = (dia.length === 1) ? '0'+dia : dia
    const mes  = (data.getMonth()+1).toString()
    const mesF = (mes.length === 1) ? '0'+mes : mes
    const anoF = data.getFullYear()
  
   return `${anoF}-${mesF}-${diaF}`
  }

  
export const getEnv = ():number => {
    // 1 Produção, 2 Test, 3 Local, 4 Talentum Test
    return 1
}

const teamNameTranslations: Record<string, string> = {
  'méxico': 'Mexico',
  'áfrica do sul': 'South Africa',
  'coreia do sul': 'South Korea',
  'república tcheca': 'Czech Republic',
  'canadá': 'Canada',
  'bósnia-herzegovina': 'Bosnia and Herzegovina',
  'qatar': 'Qatar',
  'suíça': 'Switzerland',
  'brasil': 'Brazil',
  'marrocos': 'Morocco',
  'haiti': 'Haiti',
  'escócia': 'Scotland',
  'estados unidos': 'United States',
  'paraguai': 'Paraguay',
  'austrália': 'Australia',
  'turquia': 'Turkey',
  'alemanha': 'Germany',
  'curaçao': 'Curaçao',
  'costa do marfim': 'Ivory Coast',
  'equador': 'Ecuador',
  'holanda': 'Netherlands',
  'japão': 'Japan',
  'suécia': 'Sweden',
  'tunísia': 'Tunisia',
  'bélgica': 'Belgium',
  'egito': 'Egypt',
  'irã': 'Iran',
  'nova zelândia': 'New Zealand',
  'espanha': 'Spain',
  'cabo verde': 'Cape Verde',
  'arábia saudita': 'Saudi Arabia',
  'uruguai': 'Uruguay',
  'frança': 'France',
  'senegal': 'Senegal',
  'iraque': 'Iraq',
  'noruega': 'Norway',
  'argentina': 'Argentina',
  'argélia': 'Algeria',
  'áustria': 'Austria',
  'jordânia': 'Jordan',
  'portugal': 'Portugal',
  'rep. dem. do congo': 'DR Congo',
  'uzbequistão': 'Uzbekistan',
  'colômbia': 'Colombia',
  'inglaterra': 'England',
  'croácia': 'Croatia',
  'gana': 'Ghana',
  'panamá': 'Panama'
};

export const translateTeamName = (name: string): string => {
  if (!name) return name;
  const stored = localStorage.getItem('selected_language');
  if (!stored) {
    return name;
  }
  try {
    const parsed = JSON.parse(stored);
    if (parsed && parsed.name_lang) {
      const langLower = parsed.name_lang.toLowerCase();
      const isPt = langLower.includes('portugues') || langLower.includes('português') || langLower.includes('brasil');
      if (!isPt) {
        const key = name.trim().toLowerCase();
        return teamNameTranslations[key] || name;
      }
    }
  } catch (e) {
    console.warn(e);
  }
  return name;
};

const countryTimezones: Record<string, string> = {
  '1': 'Europe/Paris',
  '2': 'Europe/Madrid',
  '3': 'Africa/Casablanca',
  '4': 'Europe/Budapest',
  '5': 'Europe/Rome',
  '6': 'Europe/Berlin',
  '7': 'America/Sao_Paulo',
  '8': 'Europe/Warsaw'
};

export const getLocalDateForCountry = (): Date => {
  const countryId = localStorage.getItem('us_country_id');
  const tz = (countryId && countryTimezones[countryId]) ? countryTimezones[countryId] : 'America/Sao_Paulo';
  try {
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: tz,
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hour12: false
    });
    const parts = formatter.formatToParts(new Date());
    const dateMap: Record<string, string> = {};
    parts.forEach(p => {
      dateMap[p.type] = p.value;
    });
    return new Date(
      parseInt(dateMap.year),
      parseInt(dateMap.month) - 1,
      parseInt(dateMap.day),
      parseInt(dateMap.hour),
      parseInt(dateMap.minute),
      parseInt(dateMap.second)
    );
  } catch (e) {
    console.warn('Error formatting date for country timezone, defaulting to local browser date', e);
    return new Date();
  }
};
